<template>
  <b-col md="12">
    <section class="accommodations">
      <div class="accommodations__header">
        <p class="mb-0">
          <strong class="semibold text--lg text-primary">Sistemazione degli ospiti per camera</strong><br>
          <span>Verifica che ogni camera sia adatta al numero e alla tipologia di viaggiatori altrimenti seleziona una camera diversa.</span>
        </p>
        <vb-button
          v-b-modal="'accommodations_modal'"
          :vb_options="{
            size: 'sm',
            variant: 'white'
          }"
        >
          <span>Cambia camera</span>
        </vb-button>
      </div>
      <card-recap :show_header="false" :show_footer="false" :show_matching="true" :solution="solution" />
      <div class="accommodations__alert" v-if="solution.accommodation.products.some(room => room.matched === 'danger' || room.matched === 'warning')">
        <p class="accommodations__alert-title">
          <vb-icon class="mr-1" :name="'exclamation'" :color="sass('danger')" :size="16" />
          <span>Almeno una camera non ha spazio sufficiente o è inadatta.</span>
        </p>
        <p class="accommodations__alert-desc">
          <span v-html="'Leggi qui sotto le <strong class=\'semibold\'>Condizioni per i bambini e i letti supplementari</strong> e contatta la struttura per verificare possibili eccezioni. <br>Se decidi di procedere senza verificare potrebbero essere richiesti supplementi al momento dell’arrivo in hotel.'" /><br>
          <span v-b-modal="'accommodations_modal'">Puoi scegliere nuovamente le camere.</span>
        </p>
      </div>
      <vb-modal
        :vb_options="{
          id: 'accommodations_modal',
          body_class: 'accommodations__modal',
          title: 'Modifica la tua scelta',
          size: 'md',
          button_size: 'sm',
          ok_title: 'Procedi',
          ok_only: true,
          centered: true,
        }"
        @ok="$router.push('/detail')"
      >
        <p>Se clicchi su Procedi, la precedente scelta delle camere verrà annullata e potrai farla di nuovo.</p>
      </vb-modal>
    </section>
  </b-col>
</template>

<script>
import CardRecap from "@bookingv3/components/blocks/card-recap.vue"

export default {
  inheritAttrs: false,
  name: 'accommodations',

  components: {
    'card-recap': CardRecap,
  },

  props: {
    solution: Object,
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .accommodations {
    margin-top: $grid-gutter-width*2;

    &__header {
      margin-bottom: 20px;

      @include media-breakpoint-up(md) {
        display: flex;
        align-items: flex-end;
        justify-content: space-between;
      }

      .btn {
        margin-top: 20px;

        @include media-breakpoint-up(md) {
          margin-top: 0;
        }

        &-white {
          background-color: $white;
        }
      }
    }

    &__alert {
      color: $danger;
      margin-top: $grid-gutter-width/2;
      margin-left: 20px;

      &-title {
        display: flex;
        align-items: center;
        font-weight: $vb-font-weight-semibold;
        margin-bottom: 0;
      }

      &-desc {
        margin-bottom: 0;
        color: $vb-body-color;

        span:last-child, a {
          color: $info;
          text-decoration: underline;
        }
      }
    }
  }

</style>